import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Divider,
  FormControl,
  Typography,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import Grid from "@mui/system/Grid";
import { isEmpty } from "lodash";

import { ListOptions } from "../../../models/Master";
import { flexAllCentre, flexAllEnd } from "../../../styles/mui/styles/display";
import {
  AddUserInputStyle,
  AddUserModalBox,
  AddUserModalGrid,
  AutocompleteDropDownMaxWidth,
  ContentScrollable,
  DropDownMaxWidth,
  TextGridStyle,
  VerifyUser,
} from "../style/style";
import {
  ButtonCloseStyle,
  ButtonVerifyStyle,
  FaXmarkIcon,
  HorizontalDivider,
} from "../../../app/styles/styles";
import { ButtonContained } from "../../../app/common/button";
import { Controller, useForm } from "react-hook-form";
import { TextLabel } from "../../../app/common/TextLabel";
import { rules } from "../../../utils/validation/Validation";
import colors from "../../../styles/colors/colors";
import fontWeight from "../../../styles/mui/fontWeight";
import {
  DropDownPadding,
  InputTextLabel,
} from "../../../components/styles/styles";
import { FormInputDropdown } from "../../../components/FormInputDropdown";
import { MyAccountModel, UserProvider } from "../../../models/MyAccount";
import { PhoneNumberInput } from "../../../components/PhoneNumberInput";
import { getListResult, getValue, formatPhoneNumber } from "../../../utils";
import { ServiceProvider } from "../../../models/ServiceProvider";
import { UserRole } from "../../../constants/HomePage";
import {
  getAgencyListByLoggedInUser,
  getFilteredRoleType,
} from "../../../app/common";
import { ActiveDeActivePayload } from "../../../models/User";
import { Constants, Numbers } from "../../../constants/Referral";
import AgencyConfirmationModal from "./AgencyConfirmationModal";
import { FormAutocompleteSelect } from "../../../components/FormAutocompleteSelect";

export interface PropsFromState {
  masterRoleState: ListOptions[];
  loggedInUser: MyAccountModel;
  masterMfaPreferenceState: ListOptions[];
  setModalflag: (val: boolean) => void;
  modalFlag: boolean;
  selectedUserData: any;
  masterServiceProviderState: ListOptions[];
  getMfaPreference: () => void;
  getAdminSelectedUserByEmail: (userEmail: string) => void;
  adminSelectedUserDetailsState: MyAccountModel;
  updateUserDetails: (payload: MyAccountModel) => void;
  getResetPassword: (payload: FormData) => void;
  getResendRegistration: (payload: FormData) => void;
  getActivateDeactivateUser: (payload: ActiveDeActivePayload) => void;
  masterServiceProviderDefaultList: ServiceProvider[];
  getActivateDeActivateUserState: string;
  getLoggedInUserByEmail: (userEmail: string) => void;
  updateUserDetailsState: MyAccountModel;
  resetStates: (actionType: string) => void;
}

export interface Data {
  role: any;
  agency: string[];
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  mfaId: string;
}

const EditUser: React.FC<any> = ({
  modalFlag,
  setModalflag,
  masterRoleState,
  selectedUserData,
  masterMfaPreferenceState,
  masterServiceProviderState,
  getAdminSelectedUserByEmail,
  adminSelectedUserDetailsState,
  updateUserDetails,
  masterServiceProviderDefaultList,
  loggedInUser,
  getResetPassword,
  getResendRegistration,
  getActivateDeactivateUser,
  getLoggedInUserByEmail,
  updateUserDetailsState,
}) => {
  const [verifiedUserCheck, setVerifiedUserCheck] = useState<boolean>(false);
  const [isTangoAdmin, setIsTangoAdmin] = useState<boolean>(false);
  const [userStatus, setUserStatus] = useState<string>(Constants.StatusActive);
  const [nonUniqueRecords, setNonUniqueRecords] = useState<ListOptions[]>([]);
  const [mergedArray, setMergedArray] = useState<ListOptions[]>([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [selectedAgencies, setSelectedAgencies] = useState<string[]>([]);
  const [mfaPreferenceOptions, setMfaPreferenceOptions] = React.useState<any[]>([]);
  const [ssoMfaPreferenceOption, setSsoMfaPreferenceOption] = React.useState<any[]>([]);
  const [isSsoUser, setIsSsoUser] = React.useState<boolean>(false);

  const methods = useForm<any>({
    defaultValues: "",
  });
  const { handleSubmit, control, setValue, watch, getValues, reset } = methods;
  useEffect(() => {
    const subscription = watch((_value: any, { name }: any) => {
      if (name === "role" && _value.length > 0) {
        setIsTangoAdmin(checkRoleType(_value));
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  const onSubmit = (data: Data) => {
      updateUserDetails({
        ...adminSelectedUserDetailsState,
        providerPortalUser: {
          ...adminSelectedUserDetailsState.providerPortalUser,
          email: adminSelectedUserDetailsState.providerPortalUser.email,
          phoneNumber: data.phoneNumber,
          mfaId: data.mfaId,
          roleId: data.role,
          roleType:
            masterRoleState &&
            masterRoleState.filter(
              (item: ListOptions) => item.value === data.role
            )[0].label,
          firstName: adminSelectedUserDetailsState.providerPortalUser.firstName.trim(),
          lastName: adminSelectedUserDetailsState.providerPortalUser.lastName.trim(),
          userCreated: loggedInUser?.providerPortalUser?.email,
          approver: loggedInUser?.providerPortalUser?.email,
        },
        userProviderList: getFilteredAgency(isEmpty(mergedArray) ? getAgencyArrayIfNoChangesApplied() : mergedArray),
      });
    reset();
  };

  const getAgencyArrayIfNoChangesApplied = () => {

    if (checkRoleType(getValues("role"))) {
      return [];
    }

    const mergedArrayTemp = [
      ...nonUniqueRecords,
      ...getValues().agency.filter(
        (item2: ListOptions) =>
          !nonUniqueRecords.some((item1: ListOptions) => item1.value === item2.value)
      ),
    ];
    return mergedArrayTemp;
  }

  const serviceProviderList = (defaultProvider: any) => {
    const customizedArray =
      masterServiceProviderDefaultList.length > 0 &&
      masterServiceProviderDefaultList
        .filter(
          (item: any) =>
            defaultProvider &&
            defaultProvider.some(
              (itemSelectedProvider: ListOptions) =>
                itemSelectedProvider.value === item.serviceProviderId &&
                !checkRoleType(getValues("role"))
            )
        )
        .map((item: any) => ({
          providerId: item.providerId,
          dateCreated: null,
          name: item.providerName,
          formattedAddress: item.providerAddress,
          city: item.providerCity,
          state: item.providerState,
          phoneNumber: item.phone,
          npiId: item.providerNpi,
          userId: adminSelectedUserDetailsState.providerPortalUser.userId,
          serviceProviderId: item.serviceProviderId,
          serviceProviderState: item.providerState,
          taxId: item.taxId,
        }));
    return customizedArray;
  };

  const getFilteredAgency = (defaultProvider: any) => {
    return serviceProviderList(defaultProvider);
  };

  const submit = handleSubmit((data: Data) => {
    if (isTangoAdmin) {
      onSubmit(data);
    } else {
      const agencies = getValues("agency") || [];
      setSelectedAgencies(agencies);
      setConfirmationModalOpen(true);
    }
  }); 

  useEffect(() => {
    if (
      adminSelectedUserDetailsState.providerPortalUser &&
      !isEmpty(adminSelectedUserDetailsState.providerPortalUser.roleId)
    ) {
      setValue("role", adminSelectedUserDetailsState.providerPortalUser.roleId);
      setIsTangoAdmin(
        checkRoleType(adminSelectedUserDetailsState.providerPortalUser.roleId)
      );
      setValue("mfaId", adminSelectedUserDetailsState.providerPortalUser.mfaId);
      setValue("mfaSSO", 4); //TBD need to update as part of future story linked to 21965/21614
      setValue(
        "phoneNumber",
        formatPhoneNumber(adminSelectedUserDetailsState.providerPortalUser.phoneNumber)
      );
      setValue("mfaId", adminSelectedUserDetailsState.providerPortalUser.mfaId);

      const selectedUserProviderList = new Set(
        adminSelectedUserDetailsState.userProviderList.map(
          (item: UserProvider) => item.serviceProviderId
        )
      );

      const list =
        loggedInUser.providerPortalUser.roleType === UserRole.PROVIDER_ADMIN
          ? loggedInUser.userProviderList
          : masterServiceProviderDefaultList.length > Numbers.ZERO &&
          masterServiceProviderDefaultList;
      
      const result = list.filter(
        (item: ServiceProvider) =>
          selectedUserProviderList &&
          selectedUserProviderList.has(item.serviceProviderId)
      );

      const nonUniqueRecords =
        adminSelectedUserDetailsState.userProviderList.filter(
          (item2: ServiceProvider) =>
            result &&
            !result.some(
              (item1: ServiceProvider) =>
                item1.serviceProviderId === item2.serviceProviderId
            )
        );

      setNonUniqueRecords(getListResult(nonUniqueRecords));
      setValue(
        "agency",
        checkRoleType(adminSelectedUserDetailsState.providerPortalUser.roleId)
          ? null
          : getListResult(result)
      );
    }
  }, [
    setValue,
    masterRoleState,
    masterMfaPreferenceState,
    adminSelectedUserDetailsState,
  ]);
  useEffect(() => {
    getAdminSelectedUserByEmail(selectedUserData.email);
  }, [getAdminSelectedUserByEmail]);

  useEffect(() => {
    if (
      getValue(updateUserDetailsState, "providerPortalUser.email") ===
      loggedInUser?.providerPortalUser?.email
    ) {
      getLoggedInUserByEmail(
        getValue(updateUserDetailsState, "providerPortalUser.email")
      );
      setModalflag(false);
    }
  }, [updateUserDetailsState]);

  const checkRoleType = (roleType: string) => {
    const role =
      masterRoleState &&
      masterRoleState.filter((item: ListOptions) => item.value === roleType);
    return (
      role !== undefined &&
      role[0].label !== undefined &&
      role[0].label === UserRole.TANGO_ADMIN
    );
  };

  const resend = (email: string, type: number) => {
    if (type === Numbers.ONE) {
      getResendRegistration(email);
    }
    if (type === Numbers.TWO) {
      getResetPassword(email);
    }
  };

  const activateDeactivateUser = () => {
    getActivateDeactivateUser({
      userId: adminSelectedUserDetailsState.providerPortalUser?.userId,
      userCreated: loggedInUser?.providerPortalUser?.email,
      flag:
        adminSelectedUserDetailsState.providerPortalUser?.status ===
        Constants.StatusActive
          ? Numbers.ONE
          : Numbers.ZERO,
    });
  };

  const onChangeHandler = (
    _e: React.ChangeEvent<HTMLInputElement>,
    _value: number,
    name: string
  ) => {
    setValue("role", _e.target.value);
    if (name === "role" && checkRoleType(_e.target.value)) {
      setIsTangoAdmin(true);
      setValue("agency", []);
    } else {
      setValue(
        "agency",
        checkRoleType(adminSelectedUserDetailsState.providerPortalUser.roleId)
          ? []
          : getListResult(adminSelectedUserDetailsState.userProviderList, masterServiceProviderDefaultList)
      );
      setIsTangoAdmin(false);
    }
  };

  const checkIfSSOUser = () => {
    return getValue(adminSelectedUserDetailsState, "providerPortalUser.isSso", null) === true;
  }

  useEffect(() => {
    setUserStatus(
      adminSelectedUserDetailsState.providerPortalUser?.status ===
        Constants.StatusActive
        ? "Deactivate"
        : "Activate"
    );
    setIsSsoUser(checkIfSSOUser());
  }, [adminSelectedUserDetailsState]);

  const onChangeHandlerAutocomplete = (_e: any, value: any) => {
    const mergedArray = [
      ...nonUniqueRecords,
      ...value.filter(
        (item2: ListOptions) =>
          !nonUniqueRecords.some((item1: ListOptions) => item1.value === item2.value)
      ),
    ];
    setMergedArray(mergedArray);
  };

  const getMfaPreferenceOptions = () => {
    if (masterMfaPreferenceState && masterMfaPreferenceState.length > 0) {
      return masterMfaPreferenceState.filter((option: ListOptions) => option.value !== 4);
    } else {
      return [];
    }
  }

  const getSsoMfaPreferenceOption = () => {
    if (masterMfaPreferenceState && masterMfaPreferenceState.length > 0) {
      return masterMfaPreferenceState.filter((option: ListOptions) => option.value === 4);
    } else {
      return [];
    }
  }

  useEffect(() => {
    if (masterMfaPreferenceState && masterMfaPreferenceState.length > 0) {
      setMfaPreferenceOptions(getMfaPreferenceOptions());
      setSsoMfaPreferenceOption(getSsoMfaPreferenceOption());
    }
  }, [masterMfaPreferenceState]);

  return (
    <>
      <Modal
        open={modalFlag}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={flexAllCentre}
      >
        <Box sx={AddUserModalBox(false)}>
          <Grid container mb="0.4rem">
            <Grid size={{ xs: 11.5 }}>
              <Typography id="modal-modal-title" variant="h1">
                Edit User
              </Typography>
            </Grid>
            <Grid size={{ xs: 0.5 }}>
              <IconButton onClick={() => setModalflag(false)}>
                <FaXmarkIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Divider sx={HorizontalDivider} />
          <Box mb="2rem" sx={ContentScrollable}>
            <Grid container>
              <Grid pb={1} size={{ xs: 2.5 }}>
                {TextLabel("First Name :")}
                <Typography sx={TextGridStyle} pt={1} variant="subtitle1">
                  {selectedUserData.firstName}
                </Typography>
              </Grid>
              <Grid size={{ xs: 2.5 }} pb={1}>
                {TextLabel("Last Name :")}
                <Typography sx={TextGridStyle} pt={1} variant="subtitle1">
                  {selectedUserData.lastName}
                </Typography>
              </Grid>
              <Grid pb={1} size={{ xs: 2.5 }}>
                {TextLabel("Email :")}
                <Typography sx={TextGridStyle} pt={1} variant="subtitle1">
                  {selectedUserData.email}
                </Typography>
              </Grid>
              <Grid pb={1} size={{ xs: 2.5 }}>
                {TextLabel("Phone :")}
                <Typography sx={TextGridStyle} pt={1} variant="subtitle1">
                  {formatPhoneNumber(
                    adminSelectedUserDetailsState.providerPortalUser.phoneNumber
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid container sx={AddUserModalGrid}>
              <Grid size={{ xs: 12 }} sx={flexAllEnd}>
                <ButtonContained
                  id="btnResendRegistration"
                  onClick={() =>
                    resend(
                      adminSelectedUserDetailsState.providerPortalUser.email,
                      Numbers.ONE
                    )
                  }
                  label="Resend Registration"
                  style={ButtonVerifyStyle}
                />
                <ButtonContained
                  id="btnResetPassword"
                  onClick={() =>
                    resend(
                      adminSelectedUserDetailsState.providerPortalUser.email,
                      Numbers.TWO
                    )
                  }
                  label="Reset Password"
                  style={ButtonVerifyStyle}
                />
                <ButtonContained
                  id="btnDeactivate"
                  onClick={() => activateDeactivateUser()}
                  label={userStatus}
                  style={ButtonVerifyStyle}
                />
              </Grid>
            </Grid>
            <Grid size={{ xs: 12 }} sx={VerifyUser}>
              <Controller
                control={control}
                name="verifyUser"
                defaultValue={false}
                render={({ field: { onChange, ref } }) => (
                  <FormControlLabel
                    label={
                      <Typography
                        variant="body1"
                        fontWeight={fontWeight[4]}
                        color={colors.black[4]}
                      >
                        By selecting this checkbox, you are affirming that you
                        have verified the identity of the account you are
                        editing.
                      </Typography>
                    }
                    control={
                      <Checkbox
                        size="small"
                        checked={verifiedUserCheck}
                        onChange={() => {
                          onChange();
                          setVerifiedUserCheck(!verifiedUserCheck);
                        }}
                        inputRef={ref}
                        disabled={false}
                      />
                    }
                  />
                )}
              />
            </Grid>
            <Grid container pb={2} pt={2}>
              <Grid size={{ xs: 3.33 }} sx={DropDownPadding}>
                <FormControl variant="standard" fullWidth sx={DropDownMaxWidth}>
                  <FormInputDropdown
                    name="role"
                    control={control}
                    label="Choose role:"
                    helper={rules.roleType}
                    list={
                      loggedInUser.providerPortalUser.roleType ===
                      UserRole.PROVIDER_ADMIN
                        ? getFilteredRoleType(masterRoleState)
                        : masterRoleState
                    }
                    disabled={!verifiedUserCheck}
                    onChangeHandler={(
                      e: React.ChangeEvent<HTMLInputElement>,
                      value: number
                    ) => onChangeHandler(e, value, "role")}
                  />
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3.33 }} pb={2}>
                <FormControl variant="standard" fullWidth sx={DropDownMaxWidth}>
                  {!isSsoUser &&
                  <FormInputDropdown
                    name="mfaId"
                    control={control}
                    label="Choose Mfa Preference:"
                    list={mfaPreferenceOptions}
                    disabled={!verifiedUserCheck}
                  />}
                  {isSsoUser &&
                  <FormInputDropdown
                    name="mfaSSO"
                    control={control}
                    label="Choose Mfa Preference:"
                    list={ssoMfaPreferenceOption}
                    disabled={true}
                  />}
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3.33 }} pb={1}>
                <FormControl
                  variant="standard"
                  fullWidth
                  sx={{ paddingRight: 10 }}
                >
                  <PhoneNumberInput
                    name="phoneNumber"
                    control={control}
                    style={InputTextLabel}
                    helper={rules.phoneNumber}
                    disabled={!verifiedUserCheck}
                    label={"Phone Number: "}
                    mandate={true}
                    isStandard={true}
                  />
                </FormControl>
              </Grid>
              {!isTangoAdmin && (
                <Grid size={{ xs: 12 }} pb={2} pt={2} sx={DropDownPadding}>
                  {TextLabel("Agency :", true)}
                  <FormControl
                    variant="standard"
                    fullWidth
                    sx={AutocompleteDropDownMaxWidth}
                  >
                    <FormAutocompleteSelect
                      name="agency"
                      disabled={!verifiedUserCheck}
                      control={control}
                      style={AddUserInputStyle}
                      list={
                        loggedInUser.providerPortalUser.roleType !==
                        UserRole.TANGO_ADMIN
                          ? getAgencyListByLoggedInUser(
                              masterServiceProviderDefaultList,
                              loggedInUser
                            )
                          : masterServiceProviderState
                      }
                      helper={rules.agencyRequired}
                      multiple={true}
                      onChangeHandler={(e: any, value: any) =>
                        onChangeHandlerAutocomplete(e, value)
                      }
                    />
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </Box>
          <Divider sx={HorizontalDivider} />
          <Grid container sx={AddUserModalGrid}>
            <Grid size={{ xs: 12 }} sx={flexAllEnd}>
              <ButtonContained
                id="btnSubmitAddUser"
                onClick={submit}
                label="Submit"
                disabled={!verifiedUserCheck}
                style={ButtonVerifyStyle}
              />
              <ButtonContained
                id="btnCloseAddUser"
                onClick={() => setModalflag(false)}
                label="Cancel"
                style={ButtonCloseStyle}
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {confirmationModalOpen && (
        <AgencyConfirmationModal
          open={confirmationModalOpen}
          selectedAgencies={selectedAgencies}
          onClose={() => setConfirmationModalOpen(false)}
          onConfirm={() => {
            setConfirmationModalOpen(false);
            handleSubmit(onSubmit)();
          }}
        />
      )}
    </>
  );
};

export default EditUser;
